import { Component, Input, OnChanges, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { PaymentService } from '@app/core/services/payment/payment.service';
import { select, Store } from '@ngrx/store';
import { State } from '@app/core/ngrx/reducers';
import { applicationSelectors, paymentSelectors, userSelectors } from '@core/ngrx/selectors';
import { LoadingController, ModalController, NavController } from '@ionic/angular';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-request-wiretransfer',
    templateUrl: './payment-request-wiretransfer.component.html',
    styleUrls: ['./payment-request-wiretransfer.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class PaymentRequestWiretransferComponent implements OnInit {
    //
    constructor(
        private store: Store<State>,
        private modalCtrl: ModalController,
        private paymentService: PaymentService,
        private loadingController: LoadingController,
        public angulartics2GoogleTagManager: Angulartics2GoogleTagManager
    ) {}

    ngOnInit() {
        // when modal is open subscribe to current cart
    }

    async dismiss() {
        await this.modalCtrl.dismiss();
    }

    async pay(event: any) {
        //

        const loader = await this.loadingController.create({
            message: 'Please wait...',
        });

        await loader.present();

        // responds with true or false
        const wireTransferCreation = await this.paymentService.createPendingWireRecords();
        // if successful dismiss and go to wire trasnfer create page
        if (wireTransferCreation) {
            await loader.dismiss();
            await this.modalCtrl.dismiss(true);
        } else {
            // failed to create wire transfer
            await loader.dismiss();
        }
    }
}
